export const ProjectDocumentationList = [
  {
    headline: 'VCS pipeline documents1',
    documents: [
      {
        documentName: 'VCS pipeline document1',
        dateUpdated: '2021-01-01',
      },
      {
        documentName: 'VCS pipeline document v2',
        dateUpdated: '2021-01-30',
      },
    ],
  },
  {
    headline: 'VCS pipeline documents2',
    documents: [
      {
        documentName: 'VCS pipeline document2',
        dateUpdated: '2021-01-01',
      },
      {
        documentName: 'VCS pipeline document v2',
        dateUpdated: '2021-01-30',
      },
    ],
  },
  {
    headline: 'VCS pipeline documents3',
    documents: [
      {
        documentName: 'VCS pipeline document',
        dateUpdated: '2021-01-01',
      },
      {
        documentName: 'VCS pipeline document v2',
        dateUpdated: '2021-01-30',
      },
    ],
  },
  {
    headline: 'VCS pipeline documents4',
    documents: [
      {
        documentName: 'VCS pipeline document',
        dateUpdated: '2021-01-01',
      },
      {
        documentName: 'VCS pipeline document v2',
        dateUpdated: '2021-01-30',
      },
    ],
  },
];
